<template>
  <div id="app">
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Gestión de usuarios <a href="#" class="float-right" data-toggle="modal" data-target="#addUser">
            <v-icon name="hi-plus" scale="1.2" />Añadir usuario
          </a></h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="filter($event)" />
      </div>
      <div class="col-12" v-if="users && users.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1">
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }} usuarios</p>
              <!--<a href="#" data-toggle="modal" data-target="#exportData">
                <v-icon name="bi-download" scale="1.1" /> DESCARGAR
              </a>-->
            </div>
            <list :users="users" @sendRefreshRegisterList="sendRefreshRegisterList()" @selectOrder="selectOrder($event)"/>
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                      @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Usuarios por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>
    <AddUser :id="'addUser'" :modalTitle="'AÑADIR USUARIO'" :class="'modal-xl'"
      :showFooter="false" @sendRefreshRegisterList="sendRefreshRegisterList()"></AddUser>
  </div>
</template>

<script>
import ListFilters from '../Shared/UserListFilters.vue';
import AddUser from './templates/AddUser.vue';
import List from './templates/List.vue';
import axios from 'axios';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
export default {
  name: 'App',
  components: {
    ListFilters,
    List,
    AddUser,
    Pagination
  },
  created() {
    this.loadUsers();
  },
  data() {
    return {
      username: '',
      vendor:'',
      email: '',
      tenant:'',
      store:'',
      rol:'',
      users: [],
      filters: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
    };
  },
  methods: {
    filter(value) {
      this.username = value.username !== undefined ? value.username : this.username;
      this.vendor = value.vendor !== undefined ? value.vendor : this.vendor;
      this.email = value.email !== undefined ? value.email : this.email;
      this.tenant = value.tenant !== undefined ? value.tenant : this.tenant;
      this.store = value.store !== undefined ? value.store : this.store;
      this.rol = value.rol !== undefined ? value.rol : this.rol;
      this.currentPage = 0;
      this.loadUsers();
    },
    filterUsername() {
      if (this.username !== '' && this.username !== undefined) {
        this.filters = `${this.filters}username=${this.username}&`;
      }
    },
    filterVendor() {
      if (this.vendor !== '' && this.vendor !== undefined) {
        this.filters = `${this.filters}vendor=${this.vendor}&`;
      }
    },
    filterEmail() {
      if (this.email !== '' && this.email !== undefined) {
        this.filters = `${this.filters}email=${this.email}&`;
      }
    },
    filterTenant() {
      if (this.tenant !== '' && this.tenant !== undefined) {
        this.filters = `${this.filters}tenant=${this.tenant}&`;
      }
    },
    filterStore() {
      if (this.store !== '' && this.store !== undefined) {
        this.filters = `${this.filters}store=${this.store}&`;
      }
    },
    filterRol() {
      if (this.rol !== '' && this.rol !== undefined) {
        this.filters = `${this.filters}role=${this.rol}&`;
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}pagination.page=${parseInt(this.currentPage + 1)}&`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadUsers();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadUsers();
    },
    loadUsers() {
      this.filterUsername();
      this.filterVendor();
      this.filterEmail();
      this.filterTenant();
      this.filterStore();
      this.filterRol();
      this.filterPagination();

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      const vm = this;
      axios.get(`/users${this.filters}`)
        .then((response) => {
          vm.users = response.data.users;
          vm.totalItems = response.data.pagination.totalElements;
          vm.filters = '';
          vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
            ? vm.totalItems / vm.itemsPerPage
            : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

          vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
          vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
            ? vm.totalItems
            : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;
        });
    },
    sendRefreshRegisterList() {
      this.loadUsers()
    },
  },
};
</script>

<style lang="scss">

</style>
